<template>
    <div class="store-evaluation m-b-32">
        <div class="d-flex justify-content-between">
            <h3 class="store-evaluation__title">{{$t('dashboard.store_evaluation.title')}}</h3>
            <a-button type="subtle" @click="reEvaluate" :disabled="loading">
                <i class="far fa-arrow-rotate-right fz-14 m-r-8"></i>
                {{$t('dashboard.store_evaluation.re_evaluate')}}
            </a-button>
        </div>
        <p class="store-evaluation__des m-b-25">{{$t('dashboard.store_evaluation.des')}}</p>

        <div :class="[$prefixClass.row, 'row-custom']">
            <div :class="$prefixClass.col + '-12'">
                <!-- Store evaluation -->
                <store-speed :loading="loading" :speed="googleSpeed" :order="order"></store-speed>
            </div>
            <div :class="$prefixClass.col + '-12'">
                <!-- Store credibility -->
                <store-credibility :loading="loading" :listApp="listAppReview"></store-credibility>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import { types as typesAuth } from "@/modules/auth/constant";
    import { types as typesDashboard } from "./../constant";
    import StoreSpeed from "./StoreSpeed"
    import StoreCredibility from "./StoreCredibility"
    export default {
        name: "StoreEvaluation",
        components: {
            StoreSpeed,
            StoreCredibility
        },
        data() {
            return {
                data: {},
                loading: true,
                googleSpeed: 0,
                order: 100,
                listAppReview: [],
            }
        },
        computed: {
            ...mapGetters({
                isAdmin: typesAuth.getters.GET_IS_ADMIN,
                store: typesAuth.getters.GET_STORE,
                storeSpeedSummary: typesDashboard.getters.GET_STORE_SPEED,
            })
        },
        created() {
            if (Object.entries(this.storeSpeedSummary).length === 0 || !this.storeSpeedSummary) {
                this.checkSyncSpeedSummary()
            } else {
                this.loading = false
                this.googleSpeed = Number(this.storeSpeedSummary.google_point.toFixed(0))
                this.listAppReview = this.storeSpeedSummary.list_install_app
                this.order = this.storeSpeedSummary.total_order
            }
            this.listenSummaryPusher()
        },
        destroyed() {
            this.channelUnbindEvent(['speedSummary'])
        },

        methods: {
            ...mapActions({
                getStoreSpeedSumamry: typesDashboard.actions.GET_STORE_SPEED,
                speedSummaryResync: typesDashboard.actions.GET_SPEED_SUMMARY_RESYNC,
                getCheckSyncSpeedSummary: typesDashboard.actions.GET_CHECK_SYNC_SPEED_SUMMARY,
            }),
            handleClick(){
                this.$emit('startTutorial',this.tutorialInfo.key)
            },
            setData(data) {
                this.googleSpeed = Number(data.google_point.toFixed(0))
                this.listAppReview = data.list_install_app
                this.order = Number(data.total_order)
            },

            async checkSyncSpeedSummary() {
                await this.getCheckSyncSpeedSummary().then(res => {
                    let { status = false, data = {}} = res.data;
                    if (status && Object.entries(data).length == 0) {
                        this.getPoint()
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            },

            async getPoint() {
                await this.getStoreSpeedSumamry().then(res => {
                    let { status = false, data = {}} = res.data;
                    if (status) {
                        this.loading = false
                        this.setData(data)
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            },

            listenSummaryPusher() {
                let self = this;
                this.channelBindEvent({channelType: 'speedSummary'}, async (data) => {
                    if (data && data.type && (data.type == 'credibility' || data.type == 'store_speed')) {
                        self.checkSyncSpeedSummary()
                    }
                });
            },

            async reEvaluate() {
                this.loading = true
                await this.speedSummaryResync().then(res => {
                    let { status = false, data = {}} = res.data;
                    if (!status) {
                        console.error('Can not re-evaluate');
                    }
                })
                .catch(e => {
                    console.error(e);
                });
            }
        },
    }
</script>

<style lang="scss">
    .store-evaluation {
        .#{$skeleton} {
            &-avatar {
                margin-top: 8px;
            }
            &-title {
                background-image: linear-gradient(90deg, rgb(162 179 198) 25%, rgb(230, 230, 230) 37%, rgb(242, 242, 242) 63%) !important;
                width: 100% !important;
                border-radius: 8px;
            }
            &-paragraph {
                margin-top: 24px !important;
                li {
                    background: #DBE2EB;
                    border-radius: 8px;
                    height: 8px;
                    margin-top: 20px !important;
                    &:last-child {
                        width: 170px;
                        height: 40px;
                        background-image: linear-gradient(90deg, rgb(162 179 198) 25%, rgb(230, 230, 230) 37%, rgb(242, 242, 242) 63%) !important;
                        margin-top: 24px;
                    }
                }
            }
        }
        .row-custom {
            margin-left: -15px;
            margin-right: -15px;
            display: flex;
            flex-direction: row;
            flex-wrap: wrap;
            width: calc(100% + 30px);
            .a-col-12 {
                padding-left: 15px;
                padding-right: 15px;
                display: flex;
                flex-direction: row;
            }
        }
    }
</style>